<template>
  <section class="padding">
      <h3 class="customer">CUSTOMER REVIEWS</h3>
<div class="row">
    <div class="card">
         <div class="child">
              <!-- <div class="overlay"> <img src="../../assets/testi.png" alt=""></div> -->
<h3>Joseph D’sa <br>
Parent</h3>
<br>
<h4>We offer transformative online and offline yoga <br> classes for kids, aged three to fifteen. We focus <br> on the mind-body connect and making sure <br> that both girls and boys are developing <br> holistically</h4>
      </div>
      
      <div class="comma"> <img src="../../assets/comma2.png" alt=""></div>
    </div>



    <div class="card">
         <div class="child">
              <!-- <div class="overlay"> <img src="../../assets/testi.png" alt=""></div> -->
<h3>Joseph D’sa <br>
Parent</h3>
<br>
<h4>We offer transformative online and offline yoga <br> classes for kids, aged three to fifteen. We focus <br> on the mind-body connect and making sure <br> that both girls and boys are developing <br> holistically</h4>
      </div>
      
      <div class="comma"> <img src="../../assets/comma2.png" alt=""></div>
    </div>



    <div class="card">
         <div class="child">
              <!-- <div class="overlay"> <img src="../../assets/testi.png" alt=""></div> -->
<h3>Joseph D’sa <br>
Parent</h3>
<br>
<h4>We offer transformative online and offline yoga <br> classes for kids, aged three to fifteen. We focus <br> on the mind-body connect and making sure <br> that both girls and boys are developing <br> holistically</h4>
      </div>
      
      <div class="comma"> <img src="../../assets/comma2.png" alt=""></div>
    </div>
</div>



  </section>
</template>

<script>
export default {

}
</script>

<style scoped>
.padding{
    padding-top: 130px;
}
 .customer {
color: #791E94;
    font-weight: 450;
    text-align: center;
        padding-bottom: 40px;
 }  
.row{
    display: flex;
    width: 90%;
    margin: auto;
    justify-content: space-between;
    flex-wrap: wrap;
}
h4{
    color: #445268;
    font-weight: 500;
    line-height: 200%;
}
h3{
    color: #44526B;
    font-weight: 800;
}
.card{
    background: #F9F9D2;
border-radius: 20px;
/* transform: rotate(90deg); */
   width: 30%;
    height: 370px; 
    margin-bottom: 50px;
}



.child{
        display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: flex-end;
        /* padding-left: 46px;
    padding-top: 46px; */
padding: 46px;
}

.comma{
        margin-left: 375px;
    margin-top: 24px;
}
.overlay{
margin-left: -95px;
    margin-top: -104px;
}
@media (max-width: 1770px){
    .card{
           width: 879px;
           
    }
    .row{
            justify-content: center;
    }
    .comma{
       margin-left: 696px;
    margin-top: 24px;
}
}

@media (max-width: 620px){
    .card{
        width: 30%;
    }
    .comma{
        margin-left: 300px;
    margin-top: 24px;
}
}
@media (max-width: 650px){
    .card{
        width: 30%;
    }
    .comma{
        margin-left: 300px;
    margin-top: 24px;
}
}
@media (max-width: 850px){
     .card{
            width: 471px;
    }
 
    .comma{
        margin-left: 500px;
    margin-top: 24px;
        position: relative;
    left: -127px;
    bottom: 37px;

}
@media (max-width: 540px){
     .card{
            width: 348px;
            height: 500px;
                
    }
    .comma{
        position: relative;
    left: -258px;
    bottom: 4px;
    }
}

}
@media (max-width: 390px){
.card{
                width: 301px;
    height: 449px;
    align-items: center;
    }
    .comma{
        position: relative;
    left: -305px;
    bottom: 53px;
    }
}



</style>